import { LoaderCircle } from 'lucide-react';
import { cn } from 'twyne-new.ui';

function Card({ children, className }) {
  return <div className={cn('p-3 rounded-sm w-full flex flex-col gap-4 twy-border-base border', className)}>
    {children}
  </div>
}

function Loader({ loading, children }) {
  return loading ? <div className='w-full h-full flex items-center justify-center'>
    <LoaderCircle size='30' className='animate-spin' />
  </div> : children
}

function CardSubtitle({ children }) {
  return <span className='font-bold text-xl twy-text-base-accent'>
    {children}
  </span>
}

export { Card, Loader, CardSubtitle }
